import { put, select } from 'redux-saga/effects';

const getLayerDefinition = ({ layers, layersSelected }) => {
  const layerKeys = Object.keys(layersSelected).filter(
    (key) => layersSelected[key]
  );

  return layerKeys
    .map((key) => {
      const layer = layers[key];
      return {
        key,
        checked: layersSelected[key],
        style: layer.style,
        preventFiltering: layer.preventFiltering,
        label: layer.label,
      };
    })
    .filter(({ preventFiltering }) => !preventFiltering);
};

const getParcelLayerDefinition = ({ accordian }) => {
  const defaultKeys = ['parcel_id', 'tid'];
  return accordian
    .find(({ id }) => id === 'boundary-layers')
    .layers.find(({ key }) => defaultKeys.includes(key));
};

export function* selectFallbackLayer() {
  const selectedLayers = yield select(getLayerDefinition);

  if (selectedLayers.length) {
    return;
  }
  const defaultLayer = yield select(getParcelLayerDefinition);

  yield put({
    type: 'ADD_LAYER',
    payload: {
      ...defaultLayer,
      checked: true,
    },
  });
}
